module.exports = "images/doc-cotation-add-1.860443c16f552cb6bfb21ad3703272ec.png";